module.exports = __webpack_public_path__ + "img/main_review_img_04.a40d91bd.png";